import { useNavigate } from "react-router-dom";
import CourseBlockInterface from "../../../Interfaces/CourseBlockInterface";
import StyledButton from "../../UI/StyledButton";
import { useState } from "react";
import Login from "../Autorization/Login";
import Registration from "../Autorization/Registration";
import { directus } from "../../../Api/FetchDirectus";
import { createItem } from "@directus/sdk";
import ApproveWindow from "./ApproveWindow";

const CourseListBlock = ({
  id,
  title,
  description,
  course_details,
  duration,
  hours,
  document_name,
  course_video,
  layout,
  access_type,
  modules,
  track_list,
  background_color,
  background_non_color,
  price,
  suitable,
  test_certificat_id,
  certificat_hours,
  status,
}: CourseBlockInterface) => {
  const navigate = useNavigate();
  const [openLogin, setOpenLogin] = useState(false);
  const [openRegistration, setOpenRegistration] = useState(false);
  const [openApprove, setOpenApprove] = useState(false);

  let data = {
    id: id,
    head: title,
    title: title,
    description: description,
    course_details: course_details,
    duration: duration,
    hours: hours,
    document_name: document_name,
    layout: layout,
    access_type: access_type,
    modules: modules,
    track_list: track_list,
    background_color: background_color,
    background_non_color: background_non_color,
    price: price,
    suitable: suitable,
    course_video: course_video,
    test_certificat_id: test_certificat_id,
    certificat_hours: certificat_hours,
  };

  async function open(navigation: string, details: boolean) {
    localStorage.setItem("courseInfo", JSON.stringify(data));
    if (!details) {
      if (sessionStorage.getItem("token")) {
        let myCourses =
          JSON.parse(localStorage.getItem("my_courses") || "[]") || [];

        if (!myCourses.find((item: string) => item === data.id)) {
          myCourses.push(data.id);
        }

        localStorage.setItem("my_courses", JSON.stringify(myCourses));
        if (
          data.id.toString() === localStorage.getItem("active_course") ||
          localStorage.getItem("active_course") === "null"
        ) {
          window.scrollTo(0, 0);

          localStorage.setItem("active_course", JSON.stringify(data.id));

          const age = localStorage.getItem("age");
          const gender = localStorage.getItem("gender");
          const activity = localStorage.getItem("activity");
          const position = localStorage.getItem("position");

          try {
            await directus.request(
              createItem("Course_History", {
                email: localStorage.getItem("email"),
                url: "/modules",
                course: JSON.stringify(data),
                date: JSON.stringify(new Date()),
                scales: localStorage.getItem("scales"),
                completed: localStorage.getItem("completed"),
                certificat_completed: localStorage.getItem(
                  "certificat_completed"
                ),
                certificat_link: localStorage.getItem("certificat_link"),
                my_courses: myCourses,
                active_course: data.id,
                form: JSON.stringify({
                  age: age,
                  gender: gender,
                  activity: activity,
                  position: position,
                }),
              })
            );
            window.scrollTo(0, 0);
            navigate(navigation);
          } catch (error: any) {
            sessionStorage.removeItem("token");
            navigate("/");
          }
        } else {
          setOpenApprove(true);
        }
      } else {
        setOpenRegistration(true);
      }
    } else {
      window.scrollTo(0, 0);

      navigate(navigation);
    }
  }

  return (
    <div className="coursesListBlock">
      <div className="courseBlockImageBox">
        <img
          alt=""
          src={"https://emir.gtsolifk.ru:4443/assets/" + layout}
          className="courseBlockLayout"
        />
        <div className="nonColorBlock">
          <img
            alt=""
            src={"https://emir.gtsolifk.ru:4443/assets/" + background_non_color}
            className="courseBlockBackGroundColorNon"
          />
        </div>
        <div className="colorBlock">
          <img
            alt=""
            src={"https://emir.gtsolifk.ru:4443/assets/" + background_color}
            className="courseBlockBackGroundColor"
          />
        </div>
      </div>
      <div className="courseBlockText">
        <h2>{title}</h2>
        <div className="courseBlockTextContent">
          <label>{description}</label>
          <div className="courseInfo">
            <div>
              <p>Длительность обучения: </p>
              <p className="courseInfoContent"> {duration}</p>
            </div>
            <div>
              <p>Количество часов:</p>
              <p className="courseInfoContent">{hours}</p>
            </div>

            <div>
              <p>Документы: </p>
              <p className="courseInfoContent">{document_name}</p>
            </div>
          </div>
          <div className="courseBlockFooter">
            <div className="courseBlockButtonBox">
              <StyledButton
                className="blueButton courseListButton"
                text="НАЧАТЬ ОБУЧЕНИЕ"
                onClick={() => open("/modules", false)}
              ></StyledButton>
              <StyledButton
                className="greyButton courseListButton"
                text="ПОДРОБНЕЕ"
                onClick={() => open("/course", true)}
              ></StyledButton>
            </div>
            {status && <div className="accountCourseStatus">{status}</div>}
          </div>
        </div>
      </div>

      {openLogin && (
        <Login
          close={(close: boolean) => {
            setOpenLogin(close);
          }}
          reg={(e: boolean) => setOpenRegistration(e)}
        />
      )}
      {openRegistration && (
        <Registration
          close={(e: boolean) => setOpenRegistration(e)}
          login={(e: boolean) => setOpenLogin(e)}
        />
      )}
      {openApprove && (
        <ApproveWindow
          data={data}
          close={(e: boolean) => setOpenApprove(e)}
          openReg={(e: boolean) => setOpenRegistration(e)}
        />
      )}
    </div>
  );
};

export default CourseListBlock;
